<template lang="pug">
  .container.grid-xl
    page-title(title="Revisar afiliação" icon="fas fa-clipboard-check" subtitle="Revisar a solicitação de afiliação")
    .flex-centered.full-height(v-if="loading") #[.loading.loading-lg]
    .flex-centered.full-height(v-else-if="error") #[error-box(:error="error")]
    .columns(v-else-if="filiationRequest")
      .columns.column.col-7.col-xl-12
        .column.col-7.col-sm-12.mb-2.pb-2
          card-person(:person="filiationRequest.requester" title="Solicitante")
        .column.col-5.col-sm-12.mb-2.pb-2
          .card.height-100
            .card-body
              .text-ellipsis
                | Solicitado em:
                span.text-bold  {{ filiationRequest.createdAt | toDate('DD/MM/YYYY HH:mm') }}
              .text-ellipsis
                | Status:
                span.text-bold(:class="status.class")  {{ status.label }}
        .column.col-12(v-if="filiationRequest.reviewer")
          blockquote
            p(v-if="filiationRequest.description") {{ filiationRequest.description }}
            cite.d-flex.align-center
              | -
              user-avatar.avatar-sm.mx-1(:user="filiationRequest.reviewer")
              |  {{ filiationRequest.reviewer.fullName }}
        .column.col-12.text-right(v-if="filiationRequest.status === 'waiting'")
          router-link.btn.btn-link.text-error(:to="{ name: 'filiations.requests.review.reject' }")
            i.fas.fa-times
            |  Rejeitar
          a.btn.btn-primary.ml-2(@click="onApprove")
            i.fas.fa-check
            |  Aprovar
    router-view
</template>

<script>
import filiationRequests from '@/services/filiationRequests'
import { filiationRequestStatusClasses } from '@/lib/constants'

export default {
  data() {
    return { loading: false, error: null, filiationRequest: null }
  },
  computed: {
    status() {
      return filiationRequestStatusClasses[this.filiationRequest.status] || {}
    },
  },
  methods: {
    async onApprove() {
      try {
        const options = {
          size: 'sm',
          title: 'Confirmar',
          cancelLabel: 'Cancelar',
        }
        const { ok } = await this.$dialogs.confirm(
          'Tem certeza que deseja aprovar esta solicitação?',
          options,
        )
        if (!ok) return
        this.loading = true
        await filiationRequests.approve(this.$route.params.id)
        this.$toaster.success('Filiação aprovada')
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
        this.loading = false
      }
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      this.loading = true
      const { data } = await filiationRequests.show(this.$route.params.id)
      this.filiationRequest = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
